/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Export_TitleInputs */

const en_us2_profile_editors_export_title = /** @type {(inputs: Profile_Editors_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export my data`)
};

const pt_br2_profile_editors_export_title = /** @type {(inputs: Profile_Editors_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar meus dados`)
};

const es_419_profile_editors_export_title = /** @type {(inputs: Profile_Editors_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar mis datos`)
};

const pt_pt2_profile_editors_export_title = /** @type {(inputs: Profile_Editors_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar os meus dados`)
};

const fr_fr2_profile_editors_export_title = /** @type {(inputs: Profile_Editors_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter mes données`)
};

const de_de2_profile_editors_export_title = /** @type {(inputs: Profile_Editors_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Daten exportieren`)
};

const it_it2_profile_editors_export_title = /** @type {(inputs: Profile_Editors_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta i miei dati`)
};

/**
* | output |
* | --- |
* | "Export my data" |
*
* @param {Profile_Editors_Export_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_export_title = /** @type {((inputs?: Profile_Editors_Export_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Export_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_export_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_export_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_export_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_export_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_export_title(inputs)
	return en_us2_profile_editors_export_title(inputs)
});
export { profile_editors_export_title as "profile-editors.export_title" }